export default __webpack_public_path__ + "static/media/standard-background.e444b154.webp";